import {AsyncPipe} from '@angular/common';
import {Component, Input, OnInit} from '@angular/core';
import {ReactiveFormsModule, UntypedFormControl} from '@angular/forms';

import {MatButton, MatIconButton} from '@angular/material/button';
import {MatFormField, MatLabel} from '@angular/material/form-field';
import {MatIcon} from '@angular/material/icon';
import {MatInput} from '@angular/material/input';
import {MatMenu, MatMenuItem, MatMenuTrigger} from '@angular/material/menu';
import {MatTooltip} from "@angular/material/tooltip";

import {MentionPipe} from "@app/annotation/mention.pipe";
import {Asset, AssetType, deserializeAsset, VideoAsset} from "@app/asset";
import {AuthService} from '@app/auth/auth.service';
import {IdenticonPipe} from '@app/shared/identicon.pipe';
import {User} from '@app/shared/user.service';
import {DateAgoPipe} from "@shared/date-ago.pipe";
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
import {Annotation, AnnotationService} from '../annotation.service';

enum AnnotationState {
    Idle,
    Reply,
    Delete,
    Edit,
}

@Component({
    selector: 'frog-annotation-list-item',
    templateUrl: './annotation-list-item.component.html',
    styleUrls: ['./annotation-list-item.component.scss'],
    imports: [
        MatIconButton,
        MatMenuTrigger,
        MatIcon,
        MatMenu,
        MatMenuItem,
        MatFormField,
        MatLabel,
        MatInput,
        ReactiveFormsModule,
        MatButton,
        AsyncPipe,
        IdenticonPipe,
        MatTooltip,
        DateAgoPipe,
        MentionPipe,
    ],
})
export class AnnotationListItemComponent implements OnInit {
    @Input() annotation: Annotation;
    @Input() asset: Asset;

    public contentControl: UntypedFormControl;
    public deleted: boolean;
    public state: AnnotationState;
    public AnnotationState = AnnotationState;
    public user$: Observable<User>;

    public isOwner: boolean;
    public frame: number;

    constructor(
        private annotationService: AnnotationService,
        private authService: AuthService,
    ) {
        this.contentControl = new UntypedFormControl('');
        this.state = AnnotationState.Idle;
        this.frame = -1;
    }

    ngOnInit(): void {
        this.user$ = this.authService.user.pipe(
            tap((user) => {
                this.isOwner = user.id === this.annotation.user.id;
            }),
        );

        if (this.asset && this.asset.asset_type === AssetType.Video) {
            const videoAsset = deserializeAsset(this.asset) as VideoAsset;
            this.frame = videoAsset.timeToFrame(this.annotation.timestamp);
        }
    }

    reply() {
        let parentId = this.annotation.id;
        if (this.annotation.parent !== null) {
            parentId = this.annotation.parent;
        }

        const annotation = new Annotation();
        annotation.comment = this.contentControl.value;
        annotation.timestamp = -1;
        annotation.asset = this.annotation.asset;
        annotation.parent = parentId;

        this.annotationService.create(annotation)
            .subscribe();
        this.state = AnnotationState.Idle;
        this.contentControl.reset('');
    }

    delete() {
        this.annotationService.delete(this.annotation.id)
            .subscribe(() => {
                this.deleted = true;
                this.annotationService.annotationsForAsset(this.asset.id);
            });
    }

    edit() {
        this.contentControl.setValue(this.annotation.comment);
        this.state = AnnotationState.Edit;
    }

    save() {
        this.annotationService.edit(this.annotation.id, this.contentControl.value)
            .subscribe((annotation) => {
                this.annotation.comment = annotation.comment;
            });
        this.state = AnnotationState.Idle;
        this.contentControl.reset('');
    }
}
